import ReactFullpage from "@fullpage/react-fullpage";
import HomeSection from "../../Sections/HomeSection";
import LatestEventsSection from "../../Sections/LatestEventsSection";
import BrandCultureSection from "../../Sections/BrandCultureSection";
import VideoSection from "../../Sections/VideoSection";
import BrandListSection from "../../Sections/BrandListSection";
import BrandMatrixSection from "../../Sections/BrandMatrixSection";
import EndSection from "../../Sections/EndSection";
import {useEffect, useState} from "react";

export default () => {
    const [fullPageData, setFullPageData] = useState(null);

    useEffect(() => {
        const watermark = document.querySelector(".fp-watermark");
        watermark && watermark.remove();
    }, [])

    return <div>
        <ReactFullpage
            licenseKey={'YOUR_KEY_HERE'}
            scrollingSpeed={1000}
            loopTop={false}
            loopBottom={false}
            anchors={['s1', 's2', 's3', 's4', 's5', 's6', 's7']}
            scrollOverflow={true}
            onLeave={(origin, destination, direction) => {
                console.log('onLeave event', {origin, destination, direction})
                setFullPageData({origin, destination, direction})
            }}
            render={({state, fullpageApi}) => {
                return (
                    <ReactFullpage.Wrapper>
                        <HomeSection/>
                        <LatestEventsSection/>
                        <BrandCultureSection/>
                        <VideoSection data={fullPageData}/>
                        <BrandListSection/>
                        <BrandMatrixSection/>
                        <EndSection/>
                    </ReactFullpage.Wrapper>
                );
            }}
        />
    </div>
}
